import Header from "./components/Header/Header";
import Shortlister from "./components/ShortLister/Shortlister";
import "./App.css";

function App() {
  return (
    <div className="body">
      <Header></Header>
      <Shortlister></Shortlister>
    </div>
  );
}

export default App;
